import React from 'react'
import { useSelector } from 'react-redux'
import { DownloadOutlined } from '@ant-design/icons'

const ActionBar = props => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const pb = 20 * deviceSize * 1.5 - 20 * deviceSize - 4
  const pr = 20 * deviceSize + 10 + 10 * deviceSize
  return (
    <div
      style={{
        paddingRight: pr,
        paddingBottom: pb,
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 'bold',
        ...props.style
      }}
    >
      <div>{props.children}</div>
      <div
        onClick={() => {
          props.onDownload && props.onDownload()
        }}
      >
        <DownloadOutlined style={{ fontSize: 20 * deviceSize, cursor: 'pointer' }} />
      </div>
    </div>
  )
}
export default ActionBar
